import React, { Component } from "react";
import { Div, Row, Col } from "atomize";
// import Swiper from "react-id-swiper";

import ImageCard from "../common/ImageCard";
import VideoCard from "../common/VideoCard";
import CaseStudyHome from "../home/CaseStudyHome";
import BlogHome from "../home/BlogHome";
import FullVideoCard from "../common/FullVideoCard";

import HomeImageModal from "../../modals/HomeImageModal";
import HomeVideoModal from "../../modals/HomeVideoModal";
import HomeFullVideoModal from "../../modals/HomeFullVideoModal";

import { TweenMax } from "gsap";

class HomeSlider extends Component {
  constructor(props) {
    super(props);
    this.cardWrap = React.createRef();
    this.cardsRef = [];
    this.hovered = false;
    this.translateValue = [];
    this.cardWidth = 0;
    this.count = 0;
    this.previousTouch = { x: 0, y: 0 };

    this.state = {
      showModal: false,
    };
  }

  componentDidMount() {
    this.setCardsWidth();
    this.addEvents();
    // this.cardWrap.current.addEventListener("drag", event =>
    //   event.dataTransfer.setDragImage(
    //     event.target,
    //     window.outerWidth,
    //     window.outerHeight
    //   )
    // );
  }

  componentWillUnmount() {
    this.removeEvents();

    window.removeEventListener("click", this.checkForClassRemove);
    window.removeEventListener("touch", this.checkForClassRemove);
  }

  checkForClassRemove = () => {
    setTimeout(() => {}, 1000);

    if (!document.documentElement.classList.contains("stop-home-slider")) {
      this.addEvents();
      window.removeEventListener("click", this.checkForClassRemove);
      window.removeEventListener("touch", this.checkForClassRemove);
    }
  };

  addEvents = () => {
    window.addEventListener("resize", this.setCardsWidth);
    this.cardWrap.current.addEventListener("mouseenter", this.mouseEnter);
    this.cardWrap.current.addEventListener("mouseleave", this.mouseLeave);
    this.cardWrap.current.addEventListener("mousewheel", this.onWheel);
    this.cardWrap.current.addEventListener("touchstart", this.onTouchStart);
    this.cardWrap.current.addEventListener("touchmove", this.onTouchMove);
    this.cardWrap.current.addEventListener("touchend", this.onTouchEnd);
    window.requestAnimationFrame(this.animate);
  };

  removeEvents = () => {
    window.removeEventListener("resize", this.setCardsWidth);
    this.cardWrap.current.removeEventListener("mouseenter", this.mouseEnter);
    this.cardWrap.current.removeEventListener("mouseleave", this.mouseLeave);
    this.cardWrap.current.removeEventListener("mousewheel", this.onWheel);
    this.cardWrap.current.removeEventListener("touchstart", this.onTouchStart);
    this.cardWrap.current.removeEventListener("touchmove", this.onTouchMove);
    this.cardWrap.current.removeEventListener("touchend", this.onTouchEnd);
    window.cancelAnimationFrame(this.animate);
  };

  mouseEnter = () => {
    this.hovered = true;
  };

  mouseLeave = () => {
    this.hovered = false;
  };

  setCardsWidth = () => {
    setTimeout(() => {
      const maxWrapperHeight = 500;
      this.count = this.cardsRef.length;
      const wrapperHeight = Math.min(
        this.cardWrap.current.getBoundingClientRect().height,
        maxWrapperHeight
      );
      this.cardWidth = wrapperHeight / 1.203;

      this.cardsRef.forEach((card, index) => {
        this.translateValue[index] = 0;
        card.style.minWidth = `${this.cardWidth}px`;
      });

      this.cardWrap.current.style.opacity = "1";
    }, 500);
  };

  onDrag = e => {};

  onWheel = e => {
    e.preventDefault();

    this.translateValue.forEach((value, index) => {
      this.translateValue[index] = value - e.deltaX + e.deltaY;
    });
  };

  onTouchStart = e => {
    this.previousTouch = {
      x: e.changedTouches[0].clientX,
      y: e.changedTouches[0].clientY,
    };
  };

  onTouchMove = e => {
    const newClientX = e.changedTouches[0].clientX;
    const newClientY = e.changedTouches[0].clientY;
    const deltaX = newClientX - this.previousTouch.x;
    const deltaY = newClientY - this.previousTouch.y;

    this.translateValue.forEach((value, index) => {
      this.translateValue[index] = value + deltaX + deltaY;
    });

    this.previousTouch = { x: newClientX, y: newClientY };
  };

  onTouchEnd = e => {
    const newClientX = e.changedTouches[0].clientX;
    const newClientY = e.changedTouches[0].clientY;
    const deltaX = newClientX - this.previousTouch.x;
    const deltaY = newClientY - this.previousTouch.y;

    this.translateValue.forEach((value, index) => {
      this.translateValue[index] = value + deltaX + deltaY;
    });

    this.previousTouch = { x: newClientX, y: newClientY };
  };

  toggleModal = value => {
    this.setState({ showModal: value });

    setTimeout(() => {
      if (value === false || value === undefined) {
        this.hovered = false;
      } else {
        this.hovered = true;
      }
    }, 200);
  };

  renderSliderSwitch = card => {
    switch (card.__typename) {
      case "ContentfulContentCardImage":
        return <ImageCard card={card} />;
        break;
      case "ContentfulContentCardVideo":
        return <VideoCard card={card} />;
        break;
      case "ContentfulCaseStudy":
        return <CaseStudyHome card={card} />;
        break;
      case "ContentfulBlog":
        return <BlogHome card={card} />;
        break;
      case "ContentfulContentCardFullVideo":
        return <FullVideoCard card={card} />;
        break;
      default:
        return null;
    }
  };

  renderModal = (card, index) => {
    const { showModal } = this.state;

    switch (card.__typename) {
      case "ContentfulContentCardImage":
        return (
          <HomeImageModal
            isOpen={index === showModal}
            onClose={() => this.toggleModal(false)}
            card={card}
          />
        );
        break;
      case "ContentfulContentCardVideo":
        return (
          <HomeVideoModal
            isOpen={index === showModal}
            onClose={() => this.toggleModal(false)}
            card={card}
          />
        );
        break;
      case "ContentfulContentCardFullVideo":
        return (
          <HomeFullVideoModal
            isOpen={index === showModal}
            onClose={() => this.toggleModal(false)}
            card={card}
          />
        );
        break;
      default:
        return null;
    }
  };

  animate = () => {
    if (document.documentElement.classList.contains("stop-home-slider")) {
      window.addEventListener("click", this.checkForClassRemove);
      window.addEventListener("touch", this.checkForClassRemove);
      this.removeEvents();
      return;
    }
    if (this.cardsRef[0] === null) {
      return;
    }
    this.cardsRef.forEach((element, index) => {
      if (-this.translateValue[index] - 20 > this.cardWidth * (index + 1)) {
        this.translateValue[index] =
          this.translateValue[index] + this.cardWidth * this.count;
      } else if (
        this.translateValue[index] + 20 >
        this.cardWidth * (this.count - index - 1)
      ) {
        this.translateValue[index] =
          this.translateValue[index] - this.cardWidth * this.count;
      } else if (!this.hovered) {
        this.translateValue[index] = this.translateValue[index] - 1;
      }
      TweenMax.set(element, { x: this.translateValue[index] });
    });

    window.requestAnimationFrame(this.animate);
  };

  render() {
    const { cards } = this.props;

    return (
      <>
        <Div m="1rem 0" flexGrow="1" overflow="visible">
          <Div
            d="flex"
            h="100%"
            pos="relative"
            overflow="hidden"
            className="wrapper"
            minH="300px"
            p="10px"
            overflow="visible"
            opacity="0"
            ref={this.cardWrap}
            transition
          >
            {cards.map((card, index) => (
              <Div
                p={{ x: "10px" }}
                ref={ref => (this.cardsRef[index] = ref)}
                onClick={() => this.toggleModal(index)}
              >
                <Div className="card-animation">
                  {this.renderSliderSwitch(card)}
                </Div>
              </Div>
            ))}
            {cards.map((card, index) => (
              <Div
                p={{ x: "10px" }}
                ref={ref => (this.cardsRef[cards.length + index] = ref)}
                onClick={() => this.toggleModal(index)}
              >
                <Div className="card-animation">
                  {this.renderSliderSwitch(card)}
                </Div>
              </Div>
            ))}
          </Div>
        </Div>
        {cards.map((card, index) => (
          <>{this.renderModal(card, index)}</>
        ))}
      </>
    );
  }
}

export default HomeSlider;
